<p-dialog appDialogoPadrao="pi pi-info-circle" descricao="Dados do funcionário do conselho." [header]="titulo" [(visible)]="showDialog" [style]="{ width: '52rem' }" [dismissableMask]="true" styleClass="funcionario-detalhe-dialog">
    @if (carregando()) {
        <div class="flex justify-center py-12">
            <i class="pi pi-spin pi-spinner text-3xl text-muted-color"></i>
        </div>
    } @else if (passo() === 'buscar-solicitante') {
        <!-- ── Escolha da pessoa. Esta tela não cria pessoa: escolhe uma. ──── -->
        <p class="text-sm text-muted-color mb-3">Escolha o solicitante que será registrado como funcionário.</p>

        <div class="flex flex-wrap items-center gap-3 mb-4">
            <p-iconfield class="flex-1 min-w-48">
                <p-inputicon styleClass="pi pi-search" />
                <input pInputText type="text" placeholder="Nome ou CPF..." [ngModel]="termoBusca()" (ngModelChange)="termoBusca.set($event)" (keyup.enter)="buscarSolicitante()" class="w-full" />
            </p-iconfield>
            <app-estado-select class="w-64 shrink-0" [uf]="ufBusca()" [disabled]="ufTravada()" (ufChange)="onUfBuscaChange($event)" />
            <p-button label="Buscar" icon="pi pi-search" (onClick)="buscarSolicitante()" [loading]="buscando()" />
        </div>

        @if (buscando()) {
            <div class="flex justify-center py-8"><i class="pi pi-spin pi-spinner text-2xl text-muted-color"></i></div>
        } @else if (buscou() && resultados().length === 0) {
            <p class="text-sm text-muted-color py-6 text-center">Nenhum solicitante encontrado.</p>
        } @else if (resultados().length > 0) {
            @if (resultadosTruncados) {
                <p class="text-sm text-orange-500 mb-2"><i class="pi pi-exclamation-triangle mr-1"></i>Mostrando {{ resultados().length }} de {{ totalResultados() }}. Refine a busca para encontrar quem procura.</p>
            }
            <p-table [value]="resultados()" [rowHover]="true" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Nome</th>
                        <th class="w-36">CPF</th>
                        <th class="w-20">UF</th>
                        <th class="w-24"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-s>
                    <tr>
                        <td class="font-medium">{{ s.nmSolicitante }}</td>
                        <td class="font-mono text-sm">{{ cpfDe(s.cpf) }}</td>
                        <td>{{ s.uf }}</td>
                        <td class="text-right">
                            <p-button label="Selecionar" size="small" [text]="true" (onClick)="selecionarSolicitante(s)" />
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        }
    } @else {
        <!-- ── Formulário ───────────────────────────────────────────────────── -->
        <form [formGroup]="form" class="flex flex-col gap-4">
            <!-- Pessoa: escolhida na criação, travada na edição -->
            <div class="pessoa-box">
                <div class="flex items-center justify-between gap-3">
                    <div class="flex flex-col">
                        <span class="info-rotulo">Solicitante</span>
                        <span class="font-medium">{{ solicitante()?.nmSolicitante || '—' }}</span>
                        <span class="text-xs text-muted-color font-mono">{{ cpfSolicitante }} · {{ solicitante()?.uf }}</span>
                    </div>
                    @if (!modoEdicao) {
                        <p-button label="Trocar" icon="pi pi-refresh" severity="secondary" [text]="true" size="small" (onClick)="voltarParaBusca()" />
                    } @else {
                        <p-tag severity="secondary" value="Não editável" [rounded]="true" styleClass="text-xs" />
                    }
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="flex flex-col gap-1">
                    <label for="nuMatricula" class="rotulo-campo">Matrícula</label>
                    <!-- Sem `maxlength`: o atributo trunca em silêncio e deixaria a mensagem abaixo inalcançável. -->
                    <input id="nuMatricula" pInputText type="text" formControlName="nuMatricula" [class.ng-invalid]="isInvalid('nuMatricula')" />
                    @if (isInvalid('nuMatricula')) {
                        <small class="text-red-500">A matrícula deve ter no máximo 5 caracteres.</small>
                    }
                </div>

                <div class="flex flex-col gap-1">
                    <label for="idCargo" class="rotulo-campo">Cargo</label>
                    <p-select inputId="idCargo" [appendTo]="'body'" [options]="opcoesCargos()" optionLabel="label" optionValue="value" formControlName="idCargo" placeholder="Selecione" [showClear]="true" [filter]="true" />
                </div>

                <div class="flex flex-col gap-1 md:col-span-2">
                    <label for="idEstrutura" class="rotulo-campo">Lotação</label>
                    <p-select inputId="idEstrutura" [appendTo]="'body'" [options]="opcoesEstruturas()" optionLabel="label" optionValue="value" formControlName="idEstruturaOrganizacional" placeholder="Selecione" [showClear]="true" [filter]="true" />
                </div>

                <div class="flex flex-col gap-1">
                    <label for="dtNascimento" class="rotulo-campo">Data de nascimento</label>
                    <p-datepicker inputId="dtNascimento" [appendTo]="'body'" dateFormat="dd/mm/yy" [showIcon]="true" formControlName="dtNascimento" />
                </div>

                <div class="flex flex-col gap-1">
                    <label for="dtAdmissao" class="rotulo-campo">Data de admissão</label>
                    <p-datepicker inputId="dtAdmissao" [appendTo]="'body'" dateFormat="dd/mm/yy" [showIcon]="true" formControlName="dtAdmissao" />
                </div>

                <div class="flex flex-col gap-1 md:col-span-2">
                    <label for="dtAfastamento" class="rotulo-campo">Data de afastamento</label>
                    <p-datepicker inputId="dtAfastamento" [appendTo]="'body'" dateFormat="dd/mm/yy" [showIcon]="true" formControlName="dtAfastamento" />
                    <!-- Substitui a exclusão: quem sai da instituição recebe a data, a linha permanece. -->
                    <small class="text-muted-color">Registra a saída da instituição. O cadastro é preservado.</small>
                </div>
            </div>

            <p-divider />

            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-3">
                    <p-toggleswitch inputId="inConselheiro" [ngModel]="form.value.inConselheiro === 'S'" [ngModelOptions]="{ standalone: true }" (ngModelChange)="form.patchValue({ inConselheiro: $event ? 'S' : 'N' })" />
                    <label for="inConselheiro" class="rotulo-campo mb-0">Conselheiro</label>
                </div>

                <div class="flex items-center gap-3">
                    <p-toggleswitch inputId="inResponsavel" [ngModel]="form.value.inResponsavel === 'S'" [ngModelOptions]="{ standalone: true }" (ngModelChange)="form.patchValue({ inResponsavel: $event ? 'S' : 'N' })" />
                    <label for="inResponsavel" class="rotulo-campo mb-0">Responsável</label>
                </div>

                <div class="flex items-center gap-3">
                    <p-toggleswitch inputId="inAscfm" [ngModel]="form.value.inAscfm === 'S'" [ngModelOptions]="{ standalone: true }" (ngModelChange)="form.patchValue({ inAscfm: $event ? 'S' : 'N' })" />
                    <label for="inAscfm" class="rotulo-campo mb-0">ASCFM</label>
                </div>

                <!-- ── AGR: fora do salvamento, role própria ─────────────────── -->
                @if (agrVisivel()) {
                    <div class="flex items-center gap-3">
                        <p-toggleswitch inputId="agenteAgr" [ngModel]="agenteAgr()" [ngModelOptions]="{ standalone: true }" [disabled]="agrBloqueado() || salvandoAgr()" (ngModelChange)="onAgrChange($event)" />
                        <label for="agenteAgr" class="rotulo-campo mb-0">Agente de Registro</label>
                        @if (salvandoAgr()) {
                            <i class="pi pi-spin pi-spinner text-sm text-muted-color"></i>
                        }
                        @if (motivoAgrBloqueado(); as motivo) {
                            <small class="text-muted-color">{{ motivo }}</small>
                        }
                    </div>
                }
            </div>
        </form>
    }

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" [text]="true" (onClick)="fechar()" />
        @if (passo() === 'formulario') {
            <p-button label="Salvar" icon="pi pi-check" (onClick)="salvar()" [loading]="salvando()" [disabled]="!podeSalvar" />
        }
    </ng-template>
</p-dialog>
